import { render } from "./AdvertisingCards.vue?vue&type=template&id=84ee0298"
import script from "./AdvertisingCards.vue?vue&type=script&lang=js"
export * from "./AdvertisingCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__